import React, { useState } from 'react';
import { Button } from "primereact/button";
import axios from "axios";
import EmailSendDialog from '../EmailSendDialog';


const apiUrl = process.env.REACT_APP_API_URL;

export default function DevisExisting({ devisInfo, leadData, onSnackbarMessage, onOpenSnackbar }) {
  const [emailDialogVisible, setEmailDialogVisible] = useState(false);

  const handleSendEmail = () => {
    axios
      .post(`${apiUrl}/IHM/api/apiMail/sendMailDevis.php`, {
        id: leadData.idLead,
        adminMod: localStorage.getItem("us"),
      })
      .then((res) => {
        if (res.data.success) {
          onSnackbarMessage(`Devis envoyé à ${leadData.email}`);
          onOpenSnackbar(false);
          window.location.reload();
        } else {
          onSnackbarMessage(res.data.message || "Envoi impossible");
          onOpenSnackbar(true);
        }
      })
      .catch((err) => {
        console.error("Erreur envoi mail:", err);
        onSnackbarMessage("Impossible d'envoyer l'email");
        onOpenSnackbar(true);
      });
  };

  return (
    <>
      <div className="devis-card mb-3">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: "11px", color: "#6b7280" }}>N° DEVIS</div>
            <div style={{ fontSize: "14.5px", fontWeight: 600, color: "#322915" }}>
              {devisInfo.numero_devis}
            </div>
          </div>
          <div>
            <div style={{ fontSize: "11px", color: "#6b7280" }}>DATE</div>
            <div style={{ fontSize: "13.5px", color: "#322915" }}>
              {new Date(devisInfo.date_devis).toLocaleDateString("fr-FR")}
            </div>
          </div>
          <div>
            <div style={{ fontSize: "11px", color: "#6b7280" }}>MONTANT</div>
            <div style={{ fontSize: "14.5px", fontWeight: 600, color: "#322915" }}>
              {parseFloat(devisInfo.montant_devis).toFixed(2)} €
            </div>
          </div>
        </div>
      </div>

      <div className="grid">
        <div className="col-12">
          <div className="flex gap-2 justify-content-end flex-wrap">
            {devisInfo.lien_pdf && (
              <Button
                label="PDF"
                icon="pi pi-file-pdf"
                outlined
                className="btn-outlined-clean"
                onClick={() => window.open(devisInfo.lien_pdf, "_blank")}
              />
            )}
            {devisInfo.lien_devis && (
              <Button
                label="Consulter"
                icon="pi pi-eye"
                outlined
                className="btn-outlined-clean"
                onClick={() => window.open(devisInfo.lien_devis, "_blank")}
              />
            )}
            <Button
              label="Modifier"
              icon="pi pi-pencil"
              outlined
              className="btn-outlined-clean"
              onClick={() =>
                window.open(
                  `https://unptittukenplus.vosfactures.fr/invoices/${devisInfo.idVosFactures}/edit`,
                  "_blank"
                )
              }
            />
            {/* <Button
              label="Envoyer par email"
              icon="pi pi-send"
              className="brand-btn-primary"
              style={{ fontSize: "13px" }}
              onClick={handleSendEmail}
            /> */}

             <Button
              label="Envoyer par email"
              icon="pi pi-send"
              className="brand-btn-primary"
              style={{ fontSize: "13px" }}
              onClick={() => setEmailDialogVisible(true)}
            />
          </div>
        </div>
      </div>

       <EmailSendDialog
        visible={emailDialogVisible}
        onHide={() => setEmailDialogVisible(false)}
        leadData={leadData}
        type="devis"
        onSnackbarMessage={onSnackbarMessage}
        onOpenSnackbar={onOpenSnackbar}
      />
    </>
  );
}